import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';
import { Subject, Subscription } from 'rxjs';
import { EvaluationCallBackResult, GameResult, GameResultDetails } from 'src/app/games/shared/gameResult';
import { AuthenticationService } from 'src/app/services/authentication.service';
import messagesHu from 'node_modules/devextreme/localization/messages/hu.json';
import { loadMessages, locale } from 'devextreme/localization';
import { LoginUser } from 'src/app/services/webapiclient.service';
import { GameService } from 'src/app/games/services/game.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-spell-backwards-eva',
    templateUrl: './spell-backwards-eva.component.html',
    styleUrl: './spell-backwards-eva.component.scss',
    standalone: false
})

export class SpellBackwardsEvaComponent implements OnInit, OnDestroy {
  @Input() wrResult: GameResultDetails;
  @Input() gameId: number;
  @Input() needSaveSubject:Subject<any>;
  @Output() closeEvaluationEvent = new EventEmitter<EvaluationCallBackResult>();

  private translSubs$: Subscription;
  private needSaveSubject$: Subscription;
  stylingMode = "filled"
  currentUser: LoginUser;
  error: any;
  dateFormat: string;
  uploadUrl = `${environment.uploadUrl}`;
  audioUrl1: string;

  gameResult: GameResult = <GameResult>{};
  callBackResult: EvaluationCallBackResult = <EvaluationCallBackResult>{};


  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private translation: L10nTranslationService,
    private authenticationService: AuthenticationService,
    public gameService: GameService

  ) {
    const huMessages = JSON.stringify(messagesHu['hu']);
    loadMessages({
      'hu': JSON.parse(huMessages)
    });
  }


  ngOnInit(): void {
    this.needSaveSubject$ = this.needSaveSubject.subscribe(event => {
      // called when the notifyChildren method is
      // called in the parent component
      this.saveData(event);
      //console.log(event);
    });

    this.translSubs$ = this.translation.onChange().subscribe(
      x => {
        locale(x.language);
        this.dateFormat = this.translation.translate('Core.DateFormat');
      });

    this.currentUser = this.authenticationService.currentUserValue;
    //Betüzés visszafelé hangfile
    this.audioUrl1 = this.uploadUrl + 'SPEB/' + this.wrResult.audio_sentence1;

    if (this.currentUser) {
      //this.evaluation = true;
    }
  }

  ngOnDestroy() {
    if (this.translSubs$) {
      this.translSubs$.unsubscribe();
    }
    if(this.needSaveSubject$){
      this.needSaveSubject$.unsubscribe();    
    }
  }


  handleValueChange(e) {
    const previousValue = e.previousValue;
    const newValue = e.value;
    // Event handling commands go here
    this.wrResult.result1 = this.calculateResult(e.value);
  }

  calculateResult(inp: string){
    //csak az utolsó 5 betűt vesszük figyelembe
    let txt = inp.slice(-5);
    if(txt.length == 0) return 0;

    let startIndex = 0;
    let prevIndex = -1;
    let actualIndex = 0;

    let result = 0;
    let actualResult = 0;
    do{
      for (var i = 0; i < txt.length -startIndex; ++i) {
        //actualIndex = this.wrResult.sentence1.indexOf(txt[4-i-startIndex]);
        actualIndex = this.wrResult.sentence1.toLowerCase().indexOf(txt[txt.length - 1 -i-startIndex].toLowerCase());
        if(actualIndex - 1 < prevIndex){
          //break;
        }else{
          prevIndex = actualIndex;
          actualResult ++;
        }
      }
      prevIndex = -1;
      startIndex ++;
      if(actualResult>result) result= actualResult;
      actualResult = 0; 
    }
    while(startIndex<5);


    return result;
  }

  saveData(direction) {

    //Lementjük a tesztet .pmg képként is a feladatlap riporthoz
    //this.uploadTestImage();
    this.error = null;
    let tmpResult = 0;

    if(this.wrResult.gameType != 'ACE-R' && this.wrResult.gameType != 'ACE-III' && this.wrResult.gameType != 'AKV'){
      this.wrResult.result1 = this.wrResult.result1 ? 1 : 0;
      this.wrResult.result2 = this.wrResult.result2 ? 1 : 0;
      this.wrResult.result3 = this.wrResult.result3 ? 1 : 0;
      this.wrResult.result4 = this.wrResult.result4 ? 1 : 0;
      this.wrResult.result5 = this.wrResult.result5 ? 1 : 0;
      tmpResult = this.wrResult.result1 + this.wrResult.result2 + this.wrResult.result3 + this.wrResult.result4 + this.wrResult.result5;

    }else{
      tmpResult = this.wrResult.result1;
    }



 
    // A szerver számára összeállítjuk az adatokat.

    this.wrResult.evaluation = true;
    this.gameResult.result = tmpResult;
    this.gameResult.resultDetails = JSON.stringify(this.wrResult);
    this.gameResult.subType = "SpellBackwards";
    this.gameResult.completed = true;
    this.gameResult.id = this.gameId;

    // Elküldjük a szerverre az adatokat.
    this.gameService.send(this.gameResult).subscribe(
      () => {
        //Jelezzük a hívónak, hogy vége a kiértékelésnek
        this.callBackResult.direction = direction;
        this.callBackResult.result = this.gameResult.result;
        this.closeEvaluationEvent.emit(this.callBackResult);
       }
    );

  }


}
